import api from "../lib/api";

export const createInternalUser = async (payload: any) => {
  return api.post("/api/admin/create-user", payload);
};

export const updateInternalUser = async (payload: any) => {
  let {id, ...rest} = payload;
  return api.post(`/api/admin/update-user/${id}`, rest);
};

export const deleteInternalUser = async (id: any) => {
  return api.post(`/api/admin/delete-user/${id}`);
};
